import { useEffect } from 'react'
import { useLoadSdkYuno } from '../../hooks'
import { UsePaymentStatus } from './payment-status.types'
import { useTranslation } from 'react-i18next'
import {
  getCheckoutReturnUrlInLS,
  getPaymentIdInLS,
  getPublicApiKeyInLS,
  getShowResultScreenInLS,
} from '../../utils/local-storage'
import { CountryCode } from '@yuno/sdk-web-core/dist/types'
import { buildCallbackUrl, redirectAfterResultScreen, redirectTo } from '../../utils'
import { dispatchLoaderEvent } from '../../utils/loader'

const FINAL_STATUSES = new Set(['SUCCEEDED', 'FAILED', 'CANCELLED', 'REJECTED', 'ERROR', 'DECLINED', 'EXPIRED'])

export const usePaymentStatus: UsePaymentStatus = (checkoutSession) => {
  const { isYunoLoaded } = useLoadSdkYuno()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (isYunoLoaded && checkoutSession) {
      initSdk()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isYunoLoaded, checkoutSession])

  const initSdk = async () => {
    const publicApiKey = getPublicApiKeyInLS()
    const checkoutReturnUrl = getCheckoutReturnUrlInLS()
    const paymentId = getPaymentIdInLS()
    const showResultScreen = getShowResultScreenInLS()

    if (!publicApiKey) {
      throw new Error('There is not Public Api Key')
    }

    const yuno = await Yuno.initialize(publicApiKey)

    await yuno.mountStatusPayment({
      checkoutSession,
      /**
       * Country can be one of CO, BR, CL, PE, EC, UR, MX
       */
      //eslint-disable-next-line
      //@ts-ignore
      countryCode: CountryCode.COLOMBIA,
      /**
       * Language can be one of es, en, pt
       */
      language: i18n.resolvedLanguage as Language,
      /**
       * @param {'READY_TO_PAY' | 'CREATED' | 'SUCCEEDED' | 'REJECTED' | 'CANCELLED' | 'ERROR' | 'DECLINED' | 'PENDING' | 'EXPIRED' | 'VERIFIED' | 'REFUNDED'} data
       */
      yunoPaymentResult(data) {
        if (checkoutReturnUrl?.length && FINAL_STATUSES.has(data)) {
          if (showResultScreen) {
            const url = buildCallbackUrl(checkoutReturnUrl, data, paymentId)
            redirectAfterResultScreen(url)
          } else {
            dispatchLoaderEvent({ showLoader: true })
            redirectTo(checkoutReturnUrl)
          }
        }
      },
    })
  }
}
